(() => {
    const root = document.querySelector('[data-project-musk-planner]');
    if (!root) return;

    const planner = root.querySelector('[data-pm-planner]');
    const steps = [...root.querySelectorAll('[data-pm-step]')];
    const actions = root.querySelector('[data-pm-actions]');
    const nextButton = root.querySelector('[data-pm-next]');
    const backButton = root.querySelector('[data-pm-back]');
    const restartButton = root.querySelector('[data-pm-restart]');
    const result = root.querySelector('[data-pm-result]');
    const progressText = root.querySelector('[data-pm-progress-text]');
    const progressDots = [...root.querySelectorAll('.pm-progress-dots i')];
    const legendItems = [...root.querySelectorAll('.pm-route-legend li')];

    const fields = ['country', 'timing', 'profile', 'blocker'];
    const answers = {country: '', timing: '', profile: '', blocker: ''};
    let currentStep = 0;
    let started = false;

    const countryLabels = {de: 'Alemania', es: 'España'};
    const timingLabels = {
        'no-date': 'Aún sin fecha definida',
        'one-three-months': 'Llego en 1–3 meses',
        'eight-thirty-days': 'Llego en 8–30 días',
        'this-week': 'Llego esta semana',
        'already-there': 'Ya estoy allí'
    };
    const profileLabels = {
        work: 'Trabajo o búsqueda de empleo',
        study: 'Estudios',
        family: 'Familia o pareja',
        settle: 'Instalarme o mejorar mi situación'
    };

    const actionCatalog = {
        de: {
            housing: {
                title: 'Define primero tu alojamiento de llegada',
                reason: 'La guía te ayuda a separar una estancia temporal segura de un alquiler que requiere documentación y condiciones de instalación.',
                guide: {title: 'Alojamiento temporal al llegar a Alemania: hotel, WG, piso amueblado y Anmeldung', href: '/alojamiento-temporal-alemania-anmeldung/'},
                comparison: {title: 'Mejor plataforma para buscar piso en Alemania', href: '/mejor-plataforma-para-buscar-piso-en-alemania/'}
            },
            coverage: {
                title: 'Aclara qué seguro médico necesitas antes de contratar',
                reason: 'La cobertura cambia según si llegas a trabajar, estudiar, residir o reunirte con familia. Primero identifica el requisito aplicable a tu caso.',
                guide: {title: 'Seguro médico para mudarte a Alemania: qué necesitas antes de empezar a trabajar', href: '/seguro-medico-para-mudarte-a-alemania/'},
                comparison: {title: 'Mejor seguro de salud para expats en Alemania', href: '/mejor-seguro-de-salud-para-expats-en-alemania/'}
            },
            documents: {
                title: 'Define si necesitas homologación, traducción o ambos pasos',
                reason: 'Antes de pagar una traducción, comprueba si tu profesión o título exige reconocimiento y qué documento admite la autoridad competente.',
                guide: {title: 'Homologar un título en Alemania: Anerkennung, anabin o ZAB', href: '/homologar-titulo-alemania-anerkennung-zab/'},
                comparison: {title: 'Mejor servicio de traducción jurada oficial en Europa', href: '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/'}
            },
            work: {
                title: 'Prepara el formato de CV que entiende el mercado alemán',
                reason: 'Antes de usar una herramienta, decide entre formato alemán o Europass y adapta el contenido a una candidatura concreta.',
                guide: {title: 'CV alemán o Europass: qué formato usar para buscar trabajo en Alemania', href: '/cv-aleman-o-europass/'},
                comparison: {title: 'Mejor herramienta para crear un CV europeo (ATS friendly)', href: '/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/'}
            },
            banking: {
                title: 'Revisa qué cuenta puedes abrir con tus documentos actuales',
                reason: 'La posibilidad de abrir una cuenta depende de Anmeldung, identificación y de si necesitas una cuenta básica mientras completas tu instalación.',
                guide: {title: 'Cuenta bancaria en Alemania para recién llegados: opciones con y sin Anmeldung', href: '/cuenta-bancaria-alemania-sin-anmeldung/'},
                comparison: {title: 'Mejor cuenta bancaria para extranjeros en Alemania', href: '/mejor-cuenta-bancaria-para-extranjeros-en-alemania/'}
            }
        },
        es: {
            housing: {
                title: 'Define primero el tipo de alquiler que necesitas',
                reason: 'La guía diferencia una reserva desde el extranjero de una estancia temporal y evita pagar antes de revisar contrato, fianza y documentación.',
                guide: {title: 'Alquilar piso en España desde el extranjero: documentos, reserva y pagos seguros', href: '/alquilar-piso-espana-desde-extranjero/'},
                comparison: {title: 'Mejor plataforma para buscar piso en España', href: '/mejor-plataforma-para-buscar-piso-en-espana/'}
            },
            coverage: {
                title: 'Aclara qué cobertura sanitaria te corresponde antes de contratar',
                reason: 'Antes de comparar seguros, confirma si necesitas cobertura de viaje, residencia, estudios o un requisito de visado.',
                guide: {title: 'Seguro de viaje o seguro médico para vivir en España: diferencias antes de contratar', href: '/seguro-viaje-o-seguro-medico-espana/'},
                comparison: {title: 'Mejor seguro de salud para recién llegados a España', href: '/mejor-seguro-de-salud-para-recien-llegados-a-espana/'}
            },
            documents: {
                title: 'Aclara qué trámite y documento necesitas antes de traducir',
                reason: 'La guía ordena homologación, traducción, legalización y documentación previa para evitar preparar documentos que no te pedirán.',
                guide: {title: 'Homologar un título extranjero en España: documentos, traducción y pasos previos', href: '/homologar-titulo-extranjero-espana/'},
                comparison: {title: 'Mejor servicio de traducción jurada oficial en Europa', href: '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/'}
            },
            work: {
                title: 'Comprueba tu alta laboral antes de optimizar la candidatura',
                reason: 'El primer paso disponible es entender cómo funciona el alta en la Seguridad Social. La guía específica de CV para España aún está pendiente.',
                guide: {title: 'La Seguridad Social en España: cómo darte de alta para trabajar legalmente', href: '/seguridad-social-espana/'},
                comparison: null
            },
            banking: {
                title: 'Revisa qué cuenta puedes abrir y qué documento te falta',
                reason: 'Pasaporte, NIE o TIE cambian las opciones disponibles y los criterios que debes comparar antes de elegir una cuenta.',
                guide: {title: 'Cuenta bancaria en España para extranjeros: pasaporte, NIE, comisiones y transferencias', href: '/cuenta-bancaria-espana-extranjeros/'},
                comparison: {title: 'Mejor cuenta bancaria para extranjeros en España', href: '/mejor-cuenta-bancaria-para-extranjeros-en-espana/'}
            }
        }
    };

    const resolveAction = (key) => {
        const base = actionCatalog[answers.country][key];
        const action = {...base, guide: {...base.guide}, comparison: base.comparison ? {...base.comparison} : null};

        if (key === 'housing' && ['this-week', 'already-there'].includes(answers.timing)) {
            if (answers.country === 'de') {
                action.title = 'Resuelve primero un alojamiento temporal seguro';
                action.reason = 'Con llegada inmediata, prioriza una estancia temporal verificable. El alquiler estable se revisa después con más margen.';
            } else {
                action.title = 'Resuelve primero un alojamiento temporal seguro';
                action.reason = 'Con llegada inmediata, prioriza una estancia temporal con contrato y fianza claros antes de buscar una vivienda estable.';
                action.guide = {title: 'Alquiler temporal en España para extranjeros: pasaporte, NIE, contrato y fianza', href: '/alquiler-temporal-espana-extranjeros/'};
            }
        }

        if (key === 'housing' && answers.country === 'de' && ['no-date', 'one-three-months'].includes(answers.timing)) {
            action.title = 'Prepara la búsqueda de vivienda sin SCHUFA';
            action.reason = 'Con margen de preparación, reúne primero los documentos y entiende los límites de fianza y Anmeldung antes de solicitar piso.';
            action.guide = {title: 'Alquilar piso en Alemania sin SCHUFA: documentos, fianza y solicitud desde el extranjero', href: '/alquilar-piso-alemania-sin-schufa/'};
        }

        if (key === 'coverage' && answers.country === 'de' && answers.profile === 'study') {
            action.title = 'Comprueba el seguro médico exigido para tus estudios';
            action.reason = 'Matrícula, edad y tipo de cobertura cambian qué seguro puede servirte antes de viajar a Alemania.';
            action.guide = {title: 'Seguro médico para estudiantes en Alemania: matrícula, edad y cobertura antes de viajar', href: '/seguro-medico-estudiantes-alemania/'};
        }

        if (key === 'coverage' && answers.country === 'es' && answers.profile === 'study') {
            action.title = 'Comprueba la cobertura exigida para tu visado de estudiante';
            action.reason = 'La vigencia y la cobertura sanitaria pueden ser requisitos específicos para estudiar en España.';
            action.guide = {title: 'Seguro médico para visado de estudiante en España: qué cobertura necesitas', href: '/seguro-medico-visado-estudiante-espana/'};
        }

        if (key === 'documents' && answers.country === 'es' && ['family', 'settle'].includes(answers.profile)) {
            action.title = 'Aclara si tu primer documento es el NIE o el TIE';
            action.reason = 'Para instalarte, primero identifica el trámite de extranjería que corresponde a tu situación; la traducción se evalúa después si procede.';
            action.guide = {title: 'El NIE y el TIE en España: la guía para no perder meses en el trámite', href: '/como-conseguir-nie-espana/'};
            action.comparison = null;
        }

        return action;
    };

    const track = (eventName, data = {}) => {
        if (!window.PrimoConsent || !window.PrimoConsent.has('analytics') || typeof window.gtag !== 'function') return;
        window.gtag('event', eventName, {site_area: 'project_musk', ...data});
    };

    const buildPriorityOrder = () => {
        const {timing, profile, blocker} = answers;
        const planned = [];
        const add = (key) => {
            if (key && key !== 'general' && !planned.includes(key)) planned.push(key);
        };

        if (blocker !== 'general') add(blocker);

        if (timing === 'already-there') {
            add('banking');
            add('documents');
            add('housing');
        } else if (timing === 'this-week') {
            add('housing');
            add('coverage');
            add(profile === 'work' ? 'work' : 'documents');
        } else if (timing === 'eight-thirty-days') {
            add('housing');
            add('coverage');
            add(profile === 'work' ? 'work' : 'documents');
        } else {
            add(profile === 'work' ? 'work' : 'documents');
            add('housing');
            add('coverage');
        }

        if (blocker === 'general') {
            if (timing === 'already-there') return ['banking', 'documents', 'housing'];
            if (timing === 'this-week' || timing === 'eight-thirty-days') return ['housing', 'coverage', profile === 'work' ? 'work' : 'documents'];
            return [profile === 'work' ? 'work' : 'documents', 'housing', 'coverage'];
        }

        return planned.slice(0, 3);
    };

    const waitingMessage = () => {
        if (answers.timing === 'already-there') return 'No intentes resolver todas las gestiones a la vez. Empieza por el bloqueo que hoy afecta a tu día a día.';
        if (answers.timing === 'this-week') return 'Con un plazo tan corto, prioriza una solución práctica de llegada antes de optimizar decisiones a largo plazo.';
        if (answers.timing === 'eight-thirty-days') return 'No conviertas una preparación de varias semanas en una lista de tareas para el último día.';
        return 'No necesitas contratar ni cerrar todas las decisiones hoy. Avanza primero en la preparación que desbloquea lo demás.';
    };

    const createShareUrl = () => {
        const url = new URL(window.location.href);
        fields.forEach((field) => url.searchParams.set(field, answers[field]));
        return url.toString();
    };

    const clearSharedRoute = () => {
        window.history.replaceState({}, '', window.location.pathname);
    };

    const hideResult = () => {
        result.hidden = true;
        result.innerHTML = '';
        planner.classList.remove('is-complete');
    };

    const renderResult = ({scrollToResult = false} = {}) => {
        const plan = buildPriorityOrder().map((key) => ({key, ...resolveAction(key)}));
        const shareUrl = createShareUrl();
        const country = countryLabels[answers.country];

        result.innerHTML = `
            <header class="pm-result-header">
                <p class="pm-eyebrow"><span aria-hidden="true"></span> TU RUTA PERSONAL</p>
                <h2>Esto es lo que va primero</h2>
                <p>Tu plan para ${country}: ${timingLabels[answers.timing].toLocaleLowerCase('es-ES')} · ${profileLabels[answers.profile].toLocaleLowerCase('es-ES')}.</p>
            </header>
            <ol class="pm-priorities">
                ${plan.map((item, index) => `
                    <li class="pm-priority">
                        <span class="pm-priority-number">${index + 1}</span>
                        <div>
                            <h3>${item.title}</h3>
                            <p>${item.reason}</p>
                            ${item.comparison ? `<p class="pm-content-type pm-content-type--compare">Comparador recomendado</p><a class="pm-comparison-link pm-primary-content-link" href="${item.comparison.href}" data-pm-result-action data-action="comparison_${item.key}">Comparar opciones: ${item.comparison.title} <span aria-hidden="true">→</span></a><p class="pm-content-type pm-content-type--guide">Guía para entender la decisión</p><a class="pm-guide-link" href="${item.guide.href}" data-pm-result-action data-action="guide_${item.key}">Leer la guía: ${item.guide.title} <span aria-hidden="true">→</span></a>` : `<p class="pm-content-type pm-content-type--guide">Guía recomendada</p><a class="pm-guide-link" href="${item.guide.href}" data-pm-result-action data-action="guide_${item.key}">Leer la guía: ${item.guide.title} <span aria-hidden="true">→</span></a><p class="pm-content-note">No hay comparador recomendado para esta gestión; esta guía es la fuente principal.</p>`}
                        </div>
                    </li>
                `).join('')}
            </ol>
            <aside class="pm-waiting">
                <strong>Todavía no es prioritario</strong>
                <p>${waitingMessage()}</p>
            </aside>
            <div class="pm-result-actions">
                <button class="pm-result-back" type="button" data-pm-result-back>← Volver</button>
                <button class="pm-result-restart" type="button" data-pm-result-restart>Reiniciar</button>
                <button class="pm-copy-route" type="button" data-pm-copy-route>Copiar enlace</button>
                <button class="pm-share" type="button" data-pm-share>Compartir</button>
                <form class="pm-resource-form" data-members-form="signup" data-pm-resource-signup novalidate>
                    <p class="pm-resource-country">Recursos para <strong>${country}</strong></p>
                    <input type="hidden" data-members-label value="Destino: ${country}">
                    <div class="pm-resource-email-row">
                        <label class="sr-only" for="pm-resource-email">Tu email</label>
                        <input id="pm-resource-email" data-members-email type="email" inputmode="email" autocomplete="email" placeholder="Tu email" required>
                        <button class="pm-signup" type="submit">Únete gratis para recibir recursos <span aria-hidden="true">→</span></button>
                    </div>
                    <p class="pm-resource-consent">Al unirte aceptas recibir recursos de Primo Europa. Consulta nuestra <a href="/politica-de-privacidad/">Política de Privacidad</a>.</p>
                    <p class="pm-resource-form-error" data-members-error></p>
                    <p class="pm-resource-form-success">Revisa tu correo para confirmar tu registro.</p>
                </form>
            </div>
        `;

        result.hidden = false;
        planner.classList.add('is-complete');
        actions.hidden = true;
        track('planner_completed', {country: answers.country, timing: answers.timing, profile: answers.profile, blocker: answers.blocker});

        result.querySelectorAll('[data-pm-result-action]').forEach((link) => {
            link.addEventListener('click', () => track('planner_action_clicked', {
                country: answers.country,
                timing: answers.timing,
                profile: answers.profile,
                blocker: answers.blocker,
                action: link.dataset.action
            }));
        });

        const shareButton = result.querySelector('[data-pm-share]');
        const copyButton = result.querySelector('[data-pm-copy-route]');
        const copyRouteLink = async () => {
            try {
                await navigator.clipboard.writeText(shareUrl);
                copyButton.textContent = 'Enlace copiado';
                track('planner_route_shared', {country: answers.country, method: 'copy'});
            } catch (error) {
                window.prompt('Copia este enlace para guardar tu ruta:', shareUrl);
            }
        };

        copyButton.addEventListener('click', copyRouteLink);

        shareButton.addEventListener('click', async () => {
            if (!navigator.share) {
                await copyRouteLink();
                return;
            }

            try {
                await navigator.share({
                    title: 'Mi ruta de llegada | Primo Europa',
                    text: 'Estas son mis prioridades para preparar mi llegada.',
                    url: shareUrl
                });
                shareButton.textContent = 'Ruta compartida';
                track('planner_route_shared', {country: answers.country, method: 'native'});
            } catch (error) {
                if (error && error.name === 'AbortError') return;
                await copyRouteLink();
            }
        });

        result.querySelector('[data-pm-result-back]').addEventListener('click', () => {
            hideResult();
            currentStep = fields.length - 1;
            updateStep();
            clearSharedRoute();
            root.querySelector('[data-pm-step="blocker"] h2').focus({preventScroll: true});
            planner.scrollIntoView({behavior: 'smooth', block: 'start'});
        });

        result.querySelector('[data-pm-result-restart]').addEventListener('click', () => restartPlanner());

        window.history.replaceState({}, '', new URL(shareUrl).pathname + new URL(shareUrl).search);
        if (scrollToResult) {
            window.requestAnimationFrame(() => {
                result.scrollIntoView({behavior: 'smooth', block: 'start'});
                window.setTimeout(() => result.focus({preventScroll: true}), 500);
            });
        } else {
            result.focus({preventScroll: true});
        }
    };

    const updateStep = () => {
        steps.forEach((step, index) => {
            step.hidden = index !== currentStep;
        });
        const selected = Boolean(answers[fields[currentStep]]);
        actions.hidden = false;
        nextButton.disabled = !selected;
        nextButton.textContent = currentStep === fields.length - 1 ? 'Tu plan de llegada →' : 'Continuar →';
        backButton.hidden = currentStep === 0;
        restartButton.hidden = currentStep === 0;
        progressText.textContent = `Paso ${currentStep + 1} de 4`;
        progressDots.forEach((dot, index) => dot.classList.toggle('is-active', index <= currentStep));
        legendItems.forEach((item, index) => item.classList.toggle('is-active', index <= currentStep));
    };

    const setOption = (button) => {
        const field = button.dataset.field;
        const value = button.dataset.value;
        answers[field] = value;
        const step = button.closest('[data-pm-step]');
        step.querySelectorAll(`[data-pm-option][data-field="${field}"]`).forEach((option) => {
            const active = option === button;
            option.classList.toggle('is-selected', active);
            option.setAttribute('aria-checked', String(active));
        });
        nextButton.disabled = false;

        if (!started) {
            started = true;
            track('planner_started', {country: field === 'country' ? value : 'unknown'});
        }
    };

    root.querySelectorAll('[data-pm-option]').forEach((button) => {
        button.addEventListener('click', () => setOption(button));
    });

    nextButton.addEventListener('click', () => {
        if (!answers[fields[currentStep]]) return;
        if (currentStep === fields.length - 1) {
            renderResult({scrollToResult: true});
            return;
        }
        currentStep += 1;
        updateStep();
        const nextHeading = root.querySelector(`[data-pm-step="${fields[currentStep]}"] h2`);
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        window.requestAnimationFrame(() => {
            if (isMobile) nextHeading.scrollIntoView({behavior: 'smooth', block: 'start'});
            nextHeading.focus({preventScroll: true});
        });
    });

    const restartPlanner = () => {
        hideResult();
        fields.forEach((field) => { answers[field] = ''; });
        root.querySelectorAll('[data-pm-option]').forEach((option) => {
            option.classList.remove('is-selected');
            option.setAttribute('aria-checked', 'false');
        });
        currentStep = 0;
        updateStep();
        clearSharedRoute();
        root.querySelector('[data-pm-step="country"] h2').focus({preventScroll: true});
        planner.scrollIntoView({behavior: 'smooth', block: 'start'});
        track('planner_restarted');
    };

    backButton.addEventListener('click', () => {
        hideResult();
        if (currentStep === 0) return;
        currentStep -= 1;
        updateStep();
    });

    restartButton.addEventListener('click', restartPlanner);

    const params = new URLSearchParams(window.location.search);
    const hasSharedRoute = fields.every((field) => params.get(field));
    if (hasSharedRoute && fields.every((field) => params.get(field) in (field === 'country' ? countryLabels : field === 'timing' ? timingLabels : field === 'profile' ? profileLabels : {housing: true, coverage: true, documents: true, work: true, banking: true, general: true}))) {
        fields.forEach((field) => { answers[field] = params.get(field); });
        renderResult();
    } else {
        updateStep();
    }
})();
